import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { EnergyInterfaceDetailsPage } from '../energy-interface-details-page/energy-interface-details-page';
import { EnergyInterfaceLoadCurveUpload } from '../../components/energy-interface-load-curve-upload/energy-interface-load-curve-upload';
import { Skeleton, Alert, Badge, TooltipDirective } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';

@Component({
  selector: 'app-energy-interface-details-load-curve-page',
  templateUrl: './energy-interface-details-load-curve-page.html',
  imports: [
    TranslocoPipe,
    EnergyInterfaceLoadCurveUpload,
    Skeleton,
    Alert,
    NgIcon,
    Badge,
    TooltipDirective,
  ],
})
export class EnergyInterfaceDetailsLoadCurvePage {
  protected detailsPage = inject(EnergyInterfaceDetailsPage);
}
